import { LabelsList } from '../../components/LabelsList';
import { useGeneralInfo } from '../../hooks';

export function LabelsListContainer() {
  const { labels } = useGeneralInfo();

  if (!labels.length) {
    return null;
  }

  return <LabelsList labels={labels} />;
}
